import {
  ButtonGroup,
  Button,
  ButtonGroupProps,
  Heading,
} from "@chakra-ui/react";
import { useMapContext } from "~/providers/MapContextProvider";

export const MapSwitcher = (props: ButtonGroupProps) => {
  const { title } = props;
  const { mapSelected, setMapSelected } = useMapContext();
  const handleClick = () => {
    setMapSelected((mapSelected) => !mapSelected);
  };
  return (
    <ButtonGroup
      p="16px"
      isAttached
      position="sticky"
      top={0}
      display={{ base: "flex", md: "flex", lg: "none" }}
      justifyContent="center"
      zIndex="1"
      {...props}
    >
      <Button
        border="1px solid black"
        borderRadius={"10px 0px 0px 10px"}
        w="50%"
        h={{ base: "42px", md: "57px" }}
        bgColor={!mapSelected ? "blue.400" : "blue.50"}
        onClick={handleClick}
        _active={{ bg: "blue.400" }}
        _focus={{ bg: "blue.400" }}
      >
        <Heading
          fontWeight="normal"
          color={mapSelected ? "black" : "white"}
          fontSize={{ base: "sm", md: "md" }}
        >
          {title}
        </Heading>
      </Button>
      <Button
        border="1px solid black"
        borderLeft={"none"}
        borderRadius={"0px 10px 10px 0px"}
        w="50%"
        h={{ base: "42px", md: "57px" }}
        bg={mapSelected ? "blue.400" : "blue.50"}
        color={mapSelected ? "white" : "gray.900"}
        onClick={handleClick}
        _active={{ bg: "blue.400" }}
        _focus={{ bg: "blue.400" }}
        // _hover={{ bg: "blue.400" }}
      >
        <Heading fontWeight="normal" fontSize={{ base: "sm", md: "md" }}>
          Map
        </Heading>
      </Button>
    </ButtonGroup>
  );
};
